/* @flow */

import * as React from 'react';

import { baseStyleId } from 'src/shared/app/base/constant/styleConstants';

// Remove server rendered styles to avoid duplicates
export default function useServerStylesRemoval() {
  React.useEffect(() => {
    const styleElt = document.getElementById(baseStyleId);

    if (styleElt instanceof HTMLElement && styleElt.remove) {
      styleElt.remove();
    }
  }, []);
}
